import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "typeInput", "jobTitleField", "studentFields", "parentFields" ]

  static values = {
    employeeIds: Array,
    parentId: Number
  }

  connect() {
    this.updateFieldVisibility()
  }

  updateFieldVisibility() {
    this.toggleVisibility(this.jobTitleFieldTarget, this.isEmployeeSelected())
    this.toggleVisibility(this.studentFieldsTarget, !this.isParentSelected())
    this.toggleVisibility(this.parentFieldsTarget, this.isParentSelected())
  }

  toggleVisibility(element, shouldShow) {
    if (!element) return

    element.classList.toggle("hidden", !shouldShow)
  }

  isEmployeeSelected() {
    return this.employeeIdsValue.includes(this.selectedTypeId)
  }

  isParentSelected() {
    return this.parentIdValue === this.selectedTypeId
  }

  get selectedTypeId() {
    return parseInt(this.typeInputTarget.value, 10)
  }
}
